// index.js
import { Database } from "@nozbe/watermelondb";
import { adapter } from "./adapter";
import { allModels } from "./model/models";

export const database = new Database({
  adapter: adapter,
  modelClasses: allModels,
});
